export default {
  shopNow: '지금 구매',
  preSale: '사전 판매 중',
  header: {
    title: '안전한 크립토 하드웨어 월렛',
    subtitle: '암호자산을 안전하고 쉽게 보관·관리',
  },
  introduce: {
    title: '더 나은 하드웨어 월렛을',
    subtitle: '안전 · 신뢰 · 쉬움',
    desc_1: '견고한 케이스로 지갑을 보호',
    desc_2: '밀리터리 등급 칩으로 보안 보장',
    desc_3: '사용 중 기기 자동 인식',
    desc_4: '키는 오프라인 생성 및 로컬 저장',
    desc_5: '보이는 그대로 서명 (WYSIWYS)',
    desc_6: 'PIN 코드 지원',
  },
  function: {
    title: '올인원 크립토 하드웨어 월렛',
    subtitle: '하나의 월렛으로 모든 크립토 니즈 충족',
    func_title_1: '안전 보관',
    func_desc_1:
      '세계 최고 수준 칩으로 키를 생성해 KeyPal에 저장. 1000+ 체인 지원. 본인 외 접근 불가.',
    func_title_2: '구매 및 증식',
    func_desc_2:
      '간단하고 안전하며 스마트하게 비트코인, 이더 등 암호화폐를 구매. 월렛을 벗어나지 않고도 증식 가능.',
    func_title_3: '교환 및 크로스체인',
    func_desc_3:
      '지원 체인 간 암호화폐를 수초 내 교환, 자산을 손쉽게 크로스체인 이동.',
    func_title_4: '암호의 무한한 가능성',
    func_desc_4:
      'DeFi, DApp, GameFi, NFT 등 모든 탈중앙 앱에 안전하게 접근.',
  },
  software: {
    title: 'KeyPal & TokenPocket',
    connect: '연결 방법',
    crossPlatform: '크로스플랫폼 지원',
    multiChains: '멀티체인 지원',
    supportDesc:
      '(BNB Smart Chain, Polygon, ETC, Arbitrum 등 모든 EVM 호환 체인 지원)',
    more: '더보기',
  },
  specification: {
    title: '사양',
    card_1: '코어',
    option_label_1_1: '칩',
    option_desc_1_1: 'MCU + SE',
    option_label_1_2: '인증 및 표준',
    option_desc_1_2: 'DOE, CEC, BEC, CE, FCC & RoHS',

    card_2: '배터리 및 커넥터',
    option_label_2_1: '배터리',
    option_desc_2_1: '300 mAh',
    option_label_2_2: '커넥터',
    option_desc_2_2: 'USB Type-C',

    card_3: '크기 및 무게',
    option_label_3_1: '크기',
    option_desc_3_1: '91 x 55 x 9.0(mm)',
    option_label_3_2: '무게',
    option_desc_3_2: '63(g)',

    card_4: '디스플레이',
    option_label_4_1: '스크린',
    option_desc_4_1: '2인치',
    option_label_4_2: '표시',
    option_desc_4_2: 'LCD, 컬러',
    option_label_4_3: '해상도',
    option_desc_4_3: '320 x 480',

    card_5: '호환성',
    option_desc_5_1: 'iOS, Android, macOS, Windows, Linux',

    card_6: '연결 방법',
    option_desc_6_1: 'Bluetooth & USB Type-C',

    card_7: '재질',
    option_desc_7_1: '알루미늄 합금',

    card_8: '색상',
    option_desc_8_1: '블랙, 실버, 골드',

    btnTitle: 'KeyPal 월렛 사용 준비 완료',
    btnSubTitle: '당신의 안전한 크립토 하드웨어 월렛',
  },
}
